import { Injectable, inject } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { map, skipWhile, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DiscountNavigationService {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  public canNavigate() {
    return this.store.select(UserSelectors.selectLocation).pipe(
      skipWhile((location) => location === undefined || location === null),
      take(1),
      map((location) =>
        location?.country === 'NL' || location?.country === 'BE' || location?.country === 'DE'
          ? true
          : false,
      ),
    );
  }
}
